import { IStrings } from 'localization/IStrings';
import { PatientQuickFilter } from './PatientQuickFilter';

export const createPatientQuickFilterRecord = (strings: IStrings): Record<PatientQuickFilter, string> => {
	return {
		all: strings.all,
		active: strings.onlyActive,
	};
};
